import {
  DropdownButton as DropdownButtonBase,
  DropdownButtonProps,
} from 'react-bootstrap'

import styles from './DropdownButton.module.scss'
import classNames from 'classnames'

export { styles }
export const DropdownButton = (props: DropdownButtonProps) => (
  <DropdownButtonBase
    {...props}
    className={classNames(styles.actionSelect, props.className)}
  />
)
